import { router } from '@inertiajs/react';
import { useCallback, useEffect, useState } from 'react';

import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
  CommandShortcut,
  CommandTrigger,
} from './Command';

import BugReportIcon from '@mui/icons-material/BugReport';
import BusinessIcon from '@mui/icons-material/Business';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import GridViewIcon from '@mui/icons-material/GridView';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { Typography } from '@mui/material';
import CalibrationIcon from '../svgIcons/Calibration';
import DatabaseIcon from '../svgIcons/Database';
import FileIcon from '../svgIcons/File';
import StatusIcon from '../svgIcons/Status';

function AppSearch() {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  // Toggle the menu when ⌘K is pressed
  useEffect(() => {
    const down = (e) => {
      if ((e.key === 'k' && (e.metaKey || e.ctrlKey)) || e.key === '/') {
        if (
          (e.target instanceof HTMLElement && e.target.isContentEditable) ||
          e.target instanceof HTMLInputElement ||
          e.target instanceof HTMLTextAreaElement ||
          e.target instanceof HTMLSelectElement
        ) {
          return;
        }

        e.preventDefault();
        setOpen((open) => !open);
      }
    };

    document.addEventListener('keydown', down);
    return () => document.removeEventListener('keydown', down);
  }, []);

  const runCommand = useCallback((command) => {
    setOpen(false);
    command();
  }, []);

  return (
    <>
      <CommandTrigger style={{ width: '100%' }} onClick={() => setOpen(!open)}>
        <SearchIcon />
        <Typography
          component="span"
          sx={(theme) => ({ color: theme.palette.grey[900] })}
        >
          Search...
        </Typography>
        <CommandShortcut>⌘K</CommandShortcut>
      </CommandTrigger>
      <CommandDialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <CommandInput placeholder="Type a command or search..." />

        <CommandList>
          {/* {loading && <Command.Loading>Hang on…</Command.Loading>} */}

          <CommandEmpty>No results found.</CommandEmpty>

          <CommandGroup heading="Sections">
            <CommandItem
              onSelect={() => runCommand(() => router.visit(route('home')))}
            >
              <GridViewIcon />
              Dashboards
            </CommandItem>
            <CommandItem
              onSelect={() =>
                runCommand(() => router.visit(route('downtimes.index')))
              }
            >
              <DatabaseIcon />
              Downtimes
            </CommandItem>

            <CommandItem
              onSelect={() =>
                runCommand(() => router.visit(route('action-items.index')))
              }
            >
              <StatusIcon />
              Action Items
            </CommandItem>
            <CommandItem
              onSelect={() =>
                runCommand(() => router.visit(route('document-control.show')))
              }
            >
              <FolderOpenIcon />
              Document Control
            </CommandItem>
            <CommandItem
              onSelect={() =>
                runCommand(() => router.visit(route('gages.index')))
              }
            >
              <CalibrationIcon />
              Calibration
            </CommandItem>
            <CommandItem
              onSelect={() =>
                runCommand(() =>
                  router.visit(route('inspection-sheets.users.index')),
                )
              }
            >
              <FileIcon />
              Inspection Sheets
            </CommandItem>
            <CommandItem
              onSelect={() =>
                runCommand(() => router.visit(route('work-instructions.index')))
              }
            >
              <HelpOutlineIcon />
              Work Instructions
            </CommandItem>
            <CommandItem
              onSelect={() =>
                runCommand(() => router.visit(route('audits.index')))
              }
            >
              <VerifiedUserIcon />
              Audits
            </CommandItem>
          </CommandGroup>

          <CommandSeparator />

          <CommandGroup heading="Quick Actions">
            <CommandItem
              onSelect={() =>
                runCommand(() => router.visit(route('issue-tracker.index')))
              }
            >
              <BugReportIcon />
              Create a new Issue
            </CommandItem>
            <CommandItem
              onSelect={() =>
                runCommand(() => router.visit(route('gages.create')))
              }
            >
              <SettingsIcon />
              Add a new Gage
            </CommandItem>
            <CommandItem
              onSelect={() =>
                runCommand(() =>
                  router.visit(route('inspection-sheets.create')),
                )
              }
            >
              <FileIcon />
              Create a new Inspection Sheet
            </CommandItem>
            <CommandItem
              onSelect={() =>
                runCommand(() =>
                  router.visit(route('work-instructions.create')),
                )
              }
            >
              <HelpOutlineIcon />
              Create a new Work Instruction
            </CommandItem>
            <CommandItem
              onSelect={() =>
                runCommand(() => router.visit(route('settings.company')))
              }
            >
              <BusinessIcon />
              Create a new Company
            </CommandItem>
          </CommandGroup>
        </CommandList>
      </CommandDialog>
    </>
  );
}

export default AppSearch;
